module.exports = __webpack_public_path__ + "img/icon-activity-purple.c2eb2d05.png";